import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../tooltip/tooltip';
import { IconDiscord } from '../../icons/discord';

export const FloatingButtonsDiscord: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Tooltip content={t('layout.floatingButtons.discord.tooltip')} position="top-right" arrowPosition={1.4}>
            <a
                href={'https://discord.gg/n4MYgUh9KF'}
                target={'_blank'}
                rel="noreferrer"
                className="flex h-[4.8rem] w-[4.8rem] cursor-pointer items-center justify-center rounded-[10rem] transition-[border,background] hover:bg-brand-secondary vl:rounded-b-[3.2rem] vl:rounded-t-none [&_i]:h-[1.8rem] [&_i]:w-[1.8rem] [&_i]:text-brand-secondary [&_i]:transition-colors hover:[&_i]:text-text-inverse"
            >
                <IconDiscord />
            </a>
        </Tooltip>
    );
};
